export const partyAreasData = [
  {
    id: "14",
    buttonText: "Papa John’s Bullpen Box",
    info:
      "Papa John's Bullpen Box is the perfect place for team parties, office outings and family events. This exclusive, on-field party area is located alongside the Rays bullpen and hosts 60-85 guests! If a call is made to the bullpen, you'll be close enough to hear the phone ring and cheer for your favorite Rays pitcher before he enters the game!",
    mapSrc: require("@/assets/images/PartyAreas/map-papa.png"),
    mapAlt: "Seating Map",
    imgSrc: require("@/assets/images/PartyAreas/papa-johns.jpg"),
    imgAlt: "Papa John's Bullpen",
  },
  {
    id: "15",
    buttonText: "Left Field Terrace",
    info:
      "The Left Field Terrace is the ideal venue for delivering VIP treatment to your group. The renovated area provides spacious amenities along with the exclusive benefits of a suite for you and your party. The Left Field Terrace accommodates 60-80 guests. Your guests will appreciate your attention to detail in providing this unique ballpark experience.",
    mapSrc: require("@/assets/images/PartyAreas/map-left-field.png"),
    mapAlt: "Seating Map",
    imgSrc: require("@/assets/images/PartyAreas/left-field-terrace.png"),
    imgAlt: "Left Field Terrace",
  },
  {
    id: "16",
    buttonText: "Seminole Hard Rock Tampa 162 Landing",
    info:
      "Enhance company meetings, boost employee morale, reward outstanding achievement, and have a blast doing it! The Seminole Hard Rock Tampa 162 Landing hosts 75-136 guests in an exclusive, on-field venue located alongside the visiting bullpen!",
    mapSrc: require("@/assets/images/PartyAreas/map-seminole.png"),
    mapAlt: "Seating Map",
    imgSrc: require("@/assets/images/PartyAreas/duckys.png"),
    imgAlt: "Seminole Hard Rock Landing",
  },
  {
    id: "17",
    buttonText: "200 Level Party Area",
    info:
      "The 200 Level Party Area located down the right field line can accommodate groups of 35 or more and features stadium seating along with a private area to mix and mingle. Whether you are coming with friends and family or clients and co-workers, the 200 Level Party Area is sure to be a home run!",
    mapSrc: require("@/assets/images/PartyAreas/map-press-party.png"),
    mapAlt: "Seating Map",
    imgSrc: require("@/assets/images/PartyAreas/press-level.jpg"),
    imgAlt: "200 Level Party Area",
  },
  {
    id: "18",
    buttonText: "The Daiquiri Deck",
    info:
      "The Daiquiri Deck offers a game-changing view from the heart of center field. Be on the lookout for home run balls while savoring unique catering options for your group of 30 in your exclusive area.",
    mapSrc: require("@/assets/images/PartyAreas/map-rumfish.png"),
    mapAlt: "Seating Map",
    imgSrc: require("@/assets/images/PartyAreas/Center-Field-Deck.jpg"),
    imgAlt: "Centerfield Deck",
  },
  {
    id: "19",
    buttonText: "Patio Boxes",
    info:
      "Bring your group of 10-22 to the ballpark and enjoy oversized cushioned seats with a private TV as well as complimentary snacks, hot dogs, and beverages, including Coca-Cola products, beer and wine. Additional catering options available to complete your outing!",
    mapSrc: require("@/assets/images/PartyAreas/map-patio-boxes.png"),
    mapAlt: "Seating Map",
    imgSrc: require("@/assets/images/PartyAreas/patio-boxes.png"),
    imgAlt: "Patio Boxes",
  },
];
